










































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import LoadingIndicator from '@/components/LoadingIndicator'
import RTService from '@services/RTService'
import WizardService from '@services/Wizard'
import WizardRoutes from './routes'
import WizardNavigation from './WizardNavigation'

settings =
  name: 'AudienceListingEditWizard'

  resources:
    form_audience_set:
      resourceName: 'form_audience_set'
      slug: 'suppliers/:supplierId/form_audience_sets/:formAudienceSetId/edit'

    supplier_media_kit:
      resourceName: 'supplier_media_kit'
      slug: 'suppliers/:supplierId/media_kit'

  vue:
    mixins: [
      WizardService.wizard(),
      RTService.mixin(['audience_set_sync_complete']),
    ]

    components: {
      Modal,
      LoadingIndicator,
      WizardNavigation,
    }

    data: ->
      mode: 'EDIT'
      searchTime: null

      selectedData:
        audienceAvailabilityKey: null
        itemDistributionKey: null
        onsiteActivationKey: null

      previewModal:
        show: false

    computed:
      audienceSetData: -> @prime?.form_audience_set?.data
      prototypes: -> @audienceSetData?.prototypes || {}

      member: -> @$store.member
      supplierId: -> @member.supplier.id
      audienceSetId: -> @$route.params.formAudienceSetId

      progressBarStyle: -> { width: (((@activeStep.idx + 1) / @steps.length) * 100)  + '%' }
      isFirstStep: -> @activeStep.idx is 0
      isLastStep: -> @activeStep.idx + 1 is @steps.length
      nextStep: -> @steps[@activeStep.idx + 1]

      wizardRoutes: -> WizardRoutes

      routeQuery: -> @$route.query

      selectedAudienceAvailabilityKey: -> @selectedData.audienceAvailabilityKey
      selectedAudienceAvailability: ->
        idx = @audienceSetData.audience_availabilities.findIndex((item) => item.key is @selectedAudienceAvailabilityKey)
        @audienceSetData.audience_availabilities[idx]
      selectedVenue: ->
        @audienceSetData.venues[@selectedAudienceAvailability?.venue_key]
      selectedCalendar: ->
        @audienceSetData.calendars[@selectedAudienceAvailability?.calendar_key]

      selectedItemDistributionKey: -> @selectedData.itemDistributionKey
      selectedItemDistribution: ->
        @audienceSetData.spaces[@selectedItemDistributionKey]

      selectedOnsiteActivationKey: -> @selectedData.onsiteActivationKey
      selectedOnsiteActivation: ->
        @audienceSetData.spaces[@selectedOnsiteActivationKey]

      audienceAvailabilities: ->
        @audienceSetData.audience_availabilities.map((av) =>
          av.venue = @lookupVenue av.venue_key
          av
        )

      venues: ->
        venues = {}
        for audienceAvailability in @audienceSetData.audience_availabilities
          venues[audienceAvailability.venue_key] = @audienceSetData.venues[audienceAvailability.venue_key] if audienceAvailability.venue_key
        venues

      venueTypes: ->
        restaurant: 'Restaurant'
        bar: 'Bar'
        brewery: 'Brewery/Winery/Distillery'
        hotel: 'Hotel'
        sports_club: 'Sports Club'
        barn: 'Barn'
        art_gallery: 'Art Gallery'
        stadium: 'Stadiums / Arenas'
        university: 'College / Universities'
        conference_center: 'Conference Center'
        mansion: 'Mansion'
        botonical_garden: 'Botanical Garden'
        skii_resort: 'Skii Resort'
        gym: 'Gym'
        conventional_housing: 'Apartments & Condos'
        coworking: 'Coworking'

      mediaKits: ->
        supplier: @supplier_media_kit

    mounted: ->
      @initializeSelectedData()

    methods:
      hiClose: ->
        @$router.push({ name: 'AudienceSetListPage' })

      hiPreview: ->
        @save()
        @previewModal.show = true

      onAudienceSetSyncComplete: ->
        @navToPreview() if @previewModal.show

      navToPreview: ->
        @$router.push({ name: 'AudienceSetShowPage', params: { audienceSetId: @wizard.audienceSetData.id } })

      save: ->
        clearTimeout(@time)
        @time = setTimeout(() =>
          @saveItem('prime.form_audience_set')
        , 300)

      syncData: ->
        @prime.form_audience_set.data = { ...@audienceSetData }

      syncAndSave: ->
        @syncData()
        @save()

      initializeSelectedData: ->
        for key of @selectedData
          @selectedData[key] = @$route.query[key]

      clearSelectedData: ->
        for key of @selectedData
          @removeSelectedData key

      removeSelectedData: (key) ->
        @setSelectedData key, undefined

      setSelectedData: (key, value) ->
        @$router.replace({
          query: {
            ...@$route.query,
            [key]: value
          }
        })
        @selectedData[key] = value

      removeSelectedAudienceAvailabilityKey: -> @removeSelectedData 'audienceAvailabilityKey'
      setSelectedAudienceAvailabilityKey: (key) -> @setSelectedData 'audienceAvailabilityKey', key

      removeSelectedItemDistributionKey: -> @removeSelectedData 'itemDistributionKey'
      setSelectedItemDistributionKey: (key) -> @setSelectedData 'itemDistributionKey', key

      removeSelectedOnsiteActivationKey: -> @removeSelectedData 'onsiteActivationKey'
      setSelectedOnsiteActivationKey: (key) -> @setSelectedData 'onsiteActivationKey', key

      generateRandomKey: ->
        Math.random().toString(32).slice(2)

      prototypeForVenueType: (type) ->
        venue = JSON.parse(JSON.stringify(@prototypes[type]))
        venue.key = @generateRandomKey()
        venue.name ||= @audienceSetData.title
        venue

      prototypeForCalendar: ->
        calendar = JSON.parse(JSON.stringify(@prototypes.calendar))
        calendar.key = @generateRandomKey()
        calendar

      prototypeForAudienceAvailability: ->
        audienceAvailability = JSON.parse(JSON.stringify(@prototypes.audience_availability))
        audienceAvailability.key = @generateRandomKey()
        audienceAvailability

      prototypeForItemDistribution: ->
        itemDistribution = JSON.parse(JSON.stringify(@prototypes.space.item_distribution))
        itemDistribution.key = @generateRandomKey()
        itemDistribution

      prototypeForOnsiteActivation: ->
        onsiteActivation = JSON.parse(JSON.stringify(@prototypes.space.onsite_activation))
        onsiteActivation.key = @generateRandomKey()
        onsiteActivation

      audienceAvailabilityForVenue: (venueKey) ->
        @audienceSetData.audience_availabilities.find((item) => item.venue_key is venueKey)

      audienceAvailabilitiesForSpace: (spaceKey) ->
        @audienceSetData.audience_availabilities.filter((item) => spaceKey in item.space_keys)

      lookupVenue: (venueKey) ->
        @audienceSetData.venues[venueKey] || {}

      lookupCalendar: (calendarKey) ->
        @audienceSetData.calendars[calendarKey] || {}

      lookupSpace: (spaceKey) ->
        @audienceSetData.spaces[spaceKey] || {}

      spaceImage: (space) ->
        space.default_image || space.images[0]

    watch:
      steps: ->
        @navToStepName @$route.query.step, { skipSave: true } if @$route.query.step?

      'wizard.activeStep.name': (step) ->
        return unless step and step isnt 'empty'
        @$router.push { query: { ...@$route.query, step } }

      routeQuery: (query) ->
        @navToStepName query.step, { skipSave: true } if query.step?

export default VueOptions.vue settings
